import React, {createContext, useContext} from 'react';

import {useShowMarkdownInChatView} from './useShowMarkdownInChatView';

type MarkdownSettingContextValue = {
  showMarkdownInChatView: boolean;
  setShowMarkdownInChatView: (value: boolean) => void;
};

const MarkdownSettingContext =
  createContext<MarkdownSettingContextValue | null>(null);

export const MarkdownSettingProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {showMarkdownInChatView, setShowMarkdownInChatView} =
    useShowMarkdownInChatView();
  return (
    <MarkdownSettingContext.Provider
      value={{showMarkdownInChatView, setShowMarkdownInChatView}}>
      {children}
    </MarkdownSettingContext.Provider>
  );
};

export const useMarkdownSetting = () => {
  const ctx = useContext(MarkdownSettingContext);
  const fallback = useShowMarkdownInChatView();
  return ctx ?? fallback;
};
